// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type StimmenListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetStimmenListe(): () => Promise<StimmenListe> {
  const getAPI = useGetApi();
  return useCallback(
    async () => (await getAPI()).stimmen.getStimmenListe(),
    [getAPI]
  );
}
